export const HOURS_OPTIONS = [3, 12, 24];
export const DAYS_OPTIONS = [30, 60, 90];

export const POLICE_DIVISIONS = ["All","D11","D12","D13","D14","D22","D23","D31","D32","D33","D41","D42","D43","D51","D52","D53","D55"];

export const DIVISION_LABELS = {
  D11: "D11 · Davenport / Weston",
  D12: "D12 · Annex / Runnymede",
  D13: "D13 · Etobicoke / Rexdale",
  D14: "D14 · Yorkdale / Downsview",
  D22: "D22 · North York Centre",
  D23: "D23 · Willowdale / Newtonbrook",
  D31: "D31 · Flemingdon / Victoria Park",
  D32: "D32 · Scarborough North",
  D33: "D33 · Scarborough East",
  D41: "D41 · Moss Park / St. Lawrence",
  D42: "D42 · Danforth / Greenwood",
  D43: "D43 · Scarborough West",
  D51: "D51 · Downtown / Harbourfront",
  D52: "D52 · West End / Parkdale",
  D53: "D53 · Etobicoke South",
  D55: "D55 · East York / Leslieville",
};

export const DIVISION_COORDS = {
  D11:[43.6532,-79.3832], D12:[43.6629,-79.4194], D13:[43.6761,-79.4825], D14:[43.6980,-79.4100],
  D22:[43.7282,-79.3855], D23:[43.7720,-79.4145], D31:[43.7435,-79.3105], D32:[43.7780,-79.3300],
  D33:[43.8050,-79.2650], D41:[43.6485,-79.3505], D42:[43.6710,-79.3050], D43:[43.7120,-79.2850],
  D51:[43.6550,-79.3690], D52:[43.6400,-79.4020], D53:[43.6290,-79.4600], D55:[43.6820,-79.3050],
};

export const MAJOR_POLICE_TYPES = ["SHOOTING","STABBING","ROBBERY","HOMICIDE","ASSAULT","PURSUIT","KIDNAPPING","HOSTAGE","MAJOR ACCIDENT","GUN CALL","CARJACKING"];

export const TPS_URL = "https://services.arcgis.com/S9th0jAJ7bqgIRjw/arcgis/rest/services/C4S_Public_NoGO/FeatureServer/0/query";
export const TFS_PROXY = "/api/fire";
export const DIVISIONS_GEOJSON_URL = "https://services.arcgis.com/S9th0jAJ7bqgIRjw/arcgis/rest/services/TPS_POLICE_DIVISIONS/FeatureServer/0/query?where=1%3D1&outFields=DIV,UNIT_NAME&f=geojson&outSR=4326";
